export default [
    {
        path: "/model/ft/list",
        name: "model-ft-list",
        component: () => import("@/views/model/ft/list.vue"),
    },
    {
        path: "/model/ft/create",
        name: "model-ft-create",
        component: () => import("@/views/model/ft/create.vue"),
    },
    {
        path: "/model/knowledge/list",
        name: "model-knowledge-list",
        component: () => import("@/views/model/knowledge/list.vue"),
    },
    {
        path: "/model/knowledge/create",
        name: "model-knowledge-create",
        component: () => import("@/views/model/knowledge/create.vue"),
    },
    {
        path: "/model/generate/query",
        name: "model-generate-query",
        component: () => import("@/views/model/generate/query.vue"),
    },
    {
        path: "/model/generate/list",
        name: "model-generate-list",
        component: () => import("@/views/model/generate/list.vue"),
    },
]